"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 13.11.2018
 */

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var SegmentationModelItem_1 = require("./segmentation-model-set/SegmentationModelItem");
/**
 * Entity for segmentation model.
 * Thresholds (highSalesLift, lowSalesLift, highBM2Lift) show as from which value the sales lift or proxy BM2 lift
 * is considered to be low or high.
 * This defines the boundaries for clustering all promotions within 9 possible groups defined in SegmentationModelItem.
 *
 * @author ZSr
 *
 * @param id
 * @param enableStatus
 * @param highSalesLift
 * @param lowSalesLift
 * @param highBM2Lift
 * @param segmentationModelItem
 */


var SegmentationModel =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SegmentationModel, _DomainObject_1$Domai);

  function SegmentationModel(id, enableStatus, highSalesLift, lowSalesLift, highBM2Lift, segmentationModelItem) {
    var _this;

    _classCallCheck(this, SegmentationModel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SegmentationModel).call(this));
    _this.id = id;
    _this.enableStatus = enableStatus;
    _this.highSalesLift = highSalesLift;
    _this.lowSalesLift = lowSalesLift;
    _this.highBM2Lift = highBM2Lift;
    _this.segmentationModelItem = segmentationModelItem;
    return _this;
  }

  return SegmentationModel;
}(DomainObject_1.DomainObject);

exports.SegmentationModel = SegmentationModel;

SegmentationModel.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SegmentationModel.name);
  /**
   * Get number input validators
   */

  var getNumberValidators = [];
  return {
    id: builder.id('id'),
    enableStatus: builder.bool('enableStatus'),
    highSalesLift: builder.num.apply(builder, ['highSalesLift'].concat(getNumberValidators)),
    lowSalesLift: builder.num.apply(builder, ['lowSalesLift'].concat(getNumberValidators)),
    highBM2Lift: builder.num.apply(builder, ['highBM2Lift'].concat(getNumberValidators)),
    segmentationModelItem: builder.listOf(builder.obj('segmentationModelItem', SegmentationModelItem_1.SegmentationModelItem.schema, function (mat) {
      return new SegmentationModelItem_1.SegmentationModelItem(mat.salesLift, mat.profitLift, mat.value);
    }))
  };
}();

SegmentationModel.DEFAULT = new SegmentationModel('default', true, 0.33, 0.66, 0.5, immutable_1.List.of(new SegmentationModelItem_1.SegmentationModelItem('high', 'high', 'good'), new SegmentationModelItem_1.SegmentationModelItem('ok', 'high', 'good'), new SegmentationModelItem_1.SegmentationModelItem('low', 'high', 'conditional'), new SegmentationModelItem_1.SegmentationModelItem('high', 'low', 'good'), new SegmentationModelItem_1.SegmentationModelItem('ok', 'low', 'conditional'), new SegmentationModelItem_1.SegmentationModelItem('low', 'low', 'avoid'), new SegmentationModelItem_1.SegmentationModelItem('high', 'negative', 'conditional'), new SegmentationModelItem_1.SegmentationModelItem('ok', 'negative', 'avoid'), new SegmentationModelItem_1.SegmentationModelItem('low', 'negative', 'avoid')));